export default __webpack_public_path__ + "static/media/air-handling-unit.e313177d.jpg";